// src/pages/auth/ForgotPassword.js
// Maxula
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authAPI } from '../../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error('Entrez votre email');
    try {
      setLoading(true);
      await authAPI.forgotPassword({ email });
      setSent(true);
      toast.success('Si ce compte existe, un email de récupération a été envoyé.');
    } catch (err) {
      // Pour la sécurité, on affiche le même message
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-center mb-2">Mot de passe oublié</h2>
        <p className="text-gray-500 text-center text-sm mb-6">
          Entrez votre email, nous vous enverrons un lien de réinitialisation.
        </p>
        {sent ? (
          <div className="text-center">
            <div className="text-green-600 mb-4">📧 Vérifiez votre boîte mail.</div>
            <Link to="/login" className="text-primary-600 hover:underline">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4 focus:ring-2 focus:ring-primary-500 outline-none"
            />
            <button type="submit" disabled={loading}
              className="w-full py-2.5 rounded-lg bg-primary-600 text-white font-semibold hover:bg-primary-700 disabled:opacity-60">
              {loading ? 'Envoi…' : 'Envoyer le lien'}
            </button>
            <div className="text-center mt-4">
              <Link to="/login" className="text-sm text-gray-500 hover:text-primary-600">Retour à la connexion</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
